import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import "./Classes.css";

function Classes() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    try {
      setLoading(true);
      setError(null);

      const querySnapshot = await getDocs(collection(db, "classes"));
      const classesList = [];

      querySnapshot.forEach((doc) => {
        classesList.push({
          id: doc.id, // Use Firestore document ID
          ...doc.data(),
        });
      });

      // Sort classes by title (alphabetical)
      const sortedClasses = classesList.sort((a, b) =>
        a.title.localeCompare(b.title),
      );

      setClasses(sortedClasses);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching classes:", err);
      setError("Error al cargar las clases. Por favor intenta nuevamente.");
      setLoading(false);
    }
  };

  // Get the appropriate CSS class for the image
  // If the class has an "image" field, use it, otherwise use a default or the first letter of the title
  const getImageClass = (classItem) => {
    if (classItem.image && classItem.image.trim() !== "") {
      return classItem.image.toLowerCase();
    }

    // Default fallback classes based on common class types
    const title = classItem.title.toLowerCase();
    if (
      title.includes("danza") ||
      title.includes("baile") ||
      title.includes("dance")
    ) {
      return "dance";
    }
    if (title.includes("pintura") || title.includes("paint")) {
      return "painting";
    }
    if (title.includes("yoga") || title.includes("meditación")) {
      return "yoga";
    }
    if (title.includes("foto") || title.includes("photo")) {
      return "photography";
    }
    if (title.includes("escritura") || title.includes("writing")) {
      return "writing";
    }
    if (title.includes("cerámica") || title.includes("ceramic")) {
      return "ceramics";
    }

    // Default fallback
    return "default";
  };

  return (
    <div className="classes-page">
      {/* Header */}
      <div className="classes-header">
        <div className="container">
          <h1>Actividades</h1>
          <p className="subtitle">
            Buscando la creatividad en Espacio Paradigmas...
          </p>
        </div>
      </div>

      {/* Classes Grid */}
      <div className="classes-content">
        <div className="container">
          {loading ? (
            <div className="loading-state">
              <div className="loading-spinner"></div>
              <p>Cargando clases...</p>
            </div>
          ) : error ? (
            <div className="error-state">
              <p>{error}</p>
              <button onClick={fetchClasses} className="retry-btn">
                Intentar nuevamente
              </button>
            </div>
          ) : classes.length === 0 ? (
            <div className="empty-state">
              <p>No hay clases disponibles en este momento.</p>
              <p>¡Vuelve pronto para ver nuestra oferta actualizada!</p>
            </div>
          ) : (
            <div className="classes-grid">
              {classes.map((cls) => {
                const imageClass = getImageClass(cls);
                const hasBackgroundImage =
                  cls.backgroundImage && cls.backgroundImage.trim() !== "";

                return (
                  <Link
                    key={cls.id}
                    to={`/classes/${cls.id}`}
                    className={`class-card ${imageClass}`}
                    style={
                      hasBackgroundImage
                        ? {
                            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url('${cls.backgroundImage}')`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }
                        : {}
                    }
                  >
                    <div className="class-overlay">
                      <div className="class-content">
                        <h3>{cls.title}</h3>
                        <p className="class-schedule">
                          {cls.schedule || "Horario a confirmar"}
                        </p>
                        <p className="class-description">
                          {cls.description || "Descripción no disponible"}
                        </p>
                        <div className="class-footer">
                          <span className="instructor">
                            {cls.instructor
                              ? `Con ${cls.instructor}`
                              : "Instructor por confirmar"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Info Section (optional - keep if you want it) */}
      <div className="classes-info">
        <div className="container">
          {/* You can add info back here if needed */}
        </div>
      </div>
    </div>
  );
}

export default Classes;
